import React from 'react'
import AddedPassengers from './AddedPassengers';
// import Card from "components/Card/Card.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { EmptyRecord } from "../../utils/PageUtility";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from 'classnames';
import Tabs from "components/CustomTabs/CustomTabs.jsx";
// @material-ui/icons
import AddIcon from "@material-ui/icons/Add";
import Code from "@material-ui/icons/Code";

const StyledInput = withStyles({
    formControl: {
        margin: 0
    }
})(CustomInput)

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    paragraph: {
        color: '#999999',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0,
        fontSize: '0.85em'
    },
    heading: {
        color: '#3C4858',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0
    },
    headerContainer: {
        display: 'flex',
        padding: '10px 0',
        justifyContent: 'space-around'
    }
};


const selectedTab = (key) => {
  this.setState({currentTab: key})
};

const ExtraPassengers = ({ classes, handleChange, addPassenger, passengers,
    removePassenger, TicketClass, TicketNumber, PassengerType, generatePassengers,
    AdultPassengers, ChildPassengers, InfantPassengers }) => {


    return (
        <div>
            <h6>Add New Passengers</h6>
            <Tabs
                headerColor="success"
                tabs={[
                    {
                        tabName: "Add",
                        tabIcon: AddIcon,
                      clickEvent: (key) => selectedTab(key),
                      tabContent: (
                            <div style={styles.headerContainer}>
                                <div style={styles.paragraph}>
                                    <StyledInput
                                        id="TicketNumber"
                                        labelText="Ticket Number"
                                        inputProps={{
                                            name: "TicketNumber",
                                            type: "text",
                                            onChange: handleChange,
                                            value: TicketNumber
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>

                                    <StyledInput
                                        id="PassengerType"
                                        labelText="Ticket Type"
                                        inputProps={{
                                            name: "PassengerType",
                                            type: "text",
                                            onChange: handleChange,
                                            value: PassengerType
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>

                                    <StyledInput classname={classNames(classes.formControl)}
                                        id="TicketClass"
                                        labelText="Ticket Class"
                                        inputProps={{
                                            name: "TicketClass",
                                            type: "text",
                                            onChange: handleChange,
                                            value: TicketClass
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>
                                    <Button type="button"
                                        color="primary"
                                        size={"md"}
                                        onClick={addPassenger}>
                                        Add
                                </Button>
                                </div>
                            </div>
                        )
                    },
                    {
                        tabName: "Auto Generate",
                        tabIcon: Code,
                      clickEvent: (key) => selectedTab(key),
                      tabContent: (
                            <div style={styles.headerContainer}>
                                <div style={styles.paragraph}>
                                    <StyledInput
                                        id="AdultPassengers"
                                        labelText="Adult Passengers"
                                        inputProps={{
                                            name: "AdultPassengers",
                                            type: "number",
                                            onChange: handleChange,
                                            value: AdultPassengers
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>

                                    <StyledInput
                                        id="ChildPassengers"
                                        labelText="Child Passengers"
                                        inputProps={{
                                            name: "ChildPassengers",
                                            type: "number",
                                            onChange: handleChange,
                                            value: ChildPassengers
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>

                                    <StyledInput classname={classNames(classes.formControl)}
                                        id="InfantPassengers"
                                        labelText="Infant Passengers"
                                        inputProps={{
                                            name: "InfantPassengers",
                                            type: "number",
                                            onChange: handleChange,
                                            value: InfantPassengers
                                        }}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </div>
                                <div style={styles.paragraph}>
                                    <Button type="button"
                                        color="primary"
                                        size={"md"}
                                        onClick={generatePassengers}>
                                        Generate
                             </Button>
                                </div>
                            </div>
                        )
                    }
                ]}
            />
            {/* <Card>
                <CardHeader color="success" stats icon>
                    {<div style={styles.headerContainer}>
                        <div style={styles.paragraph}>
                            <StyledInput
                                id="TicketNumber"
                                labelText="Ticket Number"
                                inputProps={{
                                    name: "TicketNumber",
                                    type: "text",
                                    onChange: handleChange,
                                    value: TicketNumber
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </div>
                        <div style={styles.paragraph}>

                            <StyledInput
                                id="PassengerType"
                                labelText="Ticket Type"
                                inputProps={{
                                    name: "PassengerType",
                                    type: "text",
                                    onChange: handleChange,
                                    value: PassengerType
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </div>
                        <div style={styles.paragraph}>

                            <StyledInput classname={classNames(classes.formControl)}
                                id="TicketClass"
                                labelText="Ticket Class"
                                inputProps={{
                                    name: "TicketClass",
                                    type: "text",
                                    onChange: handleChange,
                                    value: TicketClass
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </div>
                        <div style={styles.paragraph}>
                            <Button type="button"
                                color="primary"
                                size={"md"}
                                onClick={addPassenger}>
                                Add
                            </Button>
                        </div>
                    </div>}

                    {/* For auto-generation of passengers *}
                   </div> {
                        <div style={styles.headerContainer}>
                            <div style={styles.paragraph}>
                                <StyledInput
                                    id="AdultPassengers"
                                    labelText="Adult Passengers"
                                    inputProps={{
                                        name: "AdultPassengers",
                                        type: "text",
                                        onChange: handleChange,
                                        value: AdultPassengers
                                    }}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </div>
                            <div style={styles.paragraph}>

                                <StyledInput
                                    id="ChildPassengers"
                                    labelText="Child Passengers"
                                    inputProps={{
                                        name: "ChildPassengers",
                                        type: "text",
                                        onChange: handleChange,
                                        value: ChildPassengers
                                    }}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </div>
                            <div style={styles.paragraph}>

                                <StyledInput classname={classNames(classes.formControl)}
                                    id="InfantPassengers"
                                    labelText="Infant Passengers"
                                    inputProps={{
                                        name: "InfantPassengers",
                                        type: "text",
                                        onChange: handleChange,
                                        value: InfantPassengers
                                    }}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </div>
                            <div style={styles.paragraph}>
                                <Button type="button"
                                    color="primary"
                                    size={"md"}
                                    onClick={generatePassengers}>
                                    Generate
                             </Button>
                            </div>
                        </div>
                    }
                </CardHeader>
            </Card> */}
            {(passengers.length > 0) && <AddedPassengers
                classes={classes}
                passengers={passengers}
                removePassenger={removePassenger}
            />}
            {
                (passengers.length === 0) &&
                <EmptyRecord message={'No passenger added yet!'} />
            }
        </div>
    )

}

export default ExtraPassengers;


// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/ExtraPassengers.jsx